export const environment = {
  production: false,
  serviceUrl: 'https://sampark-qa.accoladeelectronics.com/api/',
  projectName: 'Sampark',
  headerProjectName: 'Sampark',
  environment: 'QA',
  version: '2.4.0',
};
